// extracted by mini-css-extract-plugin
module.exports = {"anchors":"PrintAnchors_anchors__ry-ud","anchor":"PrintAnchors_anchor__37B6s"};